import { type Ref, computed, onBeforeUnmount, onMounted, ref } from 'vue'

import { tw } from '@backmarket/utils/string/tw'

export function useScrollMaskClass(
  container: Readonly<Ref<HTMLDivElement | null>>,
) {
  const hasRightScroll = ref(false)
  const hasLeftScroll = ref(false)

  function onScrollAreaChange() {
    if (!container.value) return

    const { scrollWidth, clientWidth, scrollLeft } = container.value

    hasLeftScroll.value = scrollLeft > 0
    hasRightScroll.value = scrollLeft + clientWidth < scrollWidth
  }

  function scrollToNext() {
    container.value?.scrollBy({
      left: container.value.clientWidth,
      behavior: 'smooth',
    })
  }

  function scrollToPrev() {
    container.value?.scrollBy({
      left: -container.value.clientWidth,
      behavior: 'smooth',
    })
  }

  onMounted(() => {
    onScrollAreaChange()
    window.addEventListener('resize', onScrollAreaChange)

    if (!container.value) return

    container.value.addEventListener('scroll', onScrollAreaChange)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', onScrollAreaChange)

    if (!container.value) return
    container.value.removeEventListener('scroll', onScrollAreaChange)
  })

  const maskClass = computed(() => {
    if (hasLeftScroll.value && hasRightScroll.value)
      return tw`gradient-mask-lr-90`

    if (hasLeftScroll.value) return tw`gradient-mask-l-90`

    if (hasRightScroll.value) return tw`gradient-mask-r-90`

    return ''
  })

  return {
    maskClass,
    onScrollAreaChange,
    hasLeftScroll,
    hasRightScroll,
    scrollToNext,
    scrollToPrev,
  }
}
